import { userData, updateReduxStore } from "./userData";
import { combineReducers } from "redux";
import invoiceConfig from "./invoiceConfig";
import entityConfig from "./entityConfig";
import userRole from "./userRole";
import { MemberRegistrationReducer } from "./MemberRegistrationReducer";
import { LoanModuleReducer } from "./LoanModuleReducer";

const rootReducer = combineReducers({
  userData,
  updateReduxStore,
  MemberRegistrationReducer,
  LoanModuleReducer
});

export default rootReducer;
